import DisplayAttachment from "@/domain/entities/emails/DisplayAttachment";
import EmailAttachment from "@/domain/entities/emails/EmailAttachement";
import { AttachmentMetadata } from "@cs_teamwaydev/mailvista-sdk_react";

// CUSTOM_VIEW : métadonnées légères SDK (sans preview) → item d'affichage portant la `ref` pour récupérer
// la preview à la demande. Distinct de `attachmentMapper` (qui suppose preview/path déjà présents).
export const attachmentMetadataToDisplay = (
    metadata: AttachmentMetadata,
): DisplayAttachment =>
    new DisplayAttachment({
        key: `${metadata.uniqueMailvistaId}::${metadata.attachmentId}`,
        name: metadata.name,
        type: metadata.type,
        size: metadata.size,
        contentId: metadata.contentId,
        sentAt: metadata.sentAt ? new Date(metadata.sentAt) : undefined,
        ref: {
            uniqueMailvistaId: metadata.uniqueMailvistaId,
            attachmentId: metadata.attachmentId,
        },
    });

export const emailAttachmentToDisplay = (
    attachment: EmailAttachment,
): DisplayAttachment =>
    new DisplayAttachment({
        key: attachment.id,
        name: attachment.name,
        type: attachment.type,
        size: attachment.size,
        contentId: attachment.contentId,
        sentAt: attachment.sentAt,
        previewInline: attachment.preview,
        ref: attachment.uniqueMailvistaId
            ? {
                  uniqueMailvistaId: attachment.uniqueMailvistaId,
                  attachmentId: attachment.id,
              }
            : undefined,
    });
